import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';
import { CNServiceCode } from './cnservicecode';
import { SNItem } from './snitem';
import { SNItemFactory } from './snitemfactory';

@RegisterItem()
export class CNServiceCodeGroup extends CNItem {

    public codes: CNServiceCode[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNServiceCodeGroup';
    }

    public fromJson(json, emitLoaded = true) {
        super.fromJson(json, emitLoaded);
        if (typeof(json.codes) !== 'undefined' && json.codes instanceof Array) {
            const factory = new SNItemFactory();
            this.codes = factory.itemsFromJson(json.codes);
        }
    }

    public clone(): any {
        return new CNServiceCodeGroup();
    }
}
